module.exports = __webpack_public_path__ + "static/media/res7.c1abb69d.jpg";